import React, { useState } from 'react';
import { Eye, EyeOff } from "lucide-react";
import axiosInstance from "../../../../../api";

// Component for displaying and testing database connection settings
const DatabaseConnection = () => {
  // State to toggle password visibility
  const [showPassword, setShowPassword] = useState(false);
  // State to manage loading state during connection test
  const [loading, setLoading] = useState(false);
  // Static database configuration
  const [dbConfig] = useState({
    host: "localhost",
    port: "3306",
    database: "ros",
    username: "ros",
    password: "ktlnVRArf1xt93^?",
  });

  // Function to test database connection
  const testConnection = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.post(
        "/ems/test-connection",
        {
          host: dbConfig.host,
          port: dbConfig.port,
          database: dbConfig.database,
          username: dbConfig.username,
          password: dbConfig.password,
        }
      );
      alert(response.data.message);
    } catch (error) {
      alert("Connection failed: " + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  // Render the database connection settings interface
  return (
    <div className="tab-pane" id="database-connection" role="tabpanel">
      <h6 className="mt-4">Database Connection</h6>
      {/* Host input field */}
      <label>Host/Server Name</label>
      <input
        type="text"
        className="form-control mb-2"
        value={dbConfig.host}
        readOnly
      />
      {/* Port input field */}
      <label>Port</label>
      <input
        type="text"
        className="form-control mb-2"
        value={dbConfig.port}
        readOnly
      />
      {/* Database name input field */}
      <label>Database Name</label>
      <input
        type="text"
        className="form-control mb-2"
        value={dbConfig.database}
        readOnly
      />
      {/* Username input field */}
      <label>Username</label>
      <input
        type="text"
        className="form-control mb-2"
        value={dbConfig.username}
        readOnly
      />
      {/* Password input field with toggle visibility */}
      <label>Password</label>
      <div className="input-group mb-3">
        <input
          type={showPassword ? "text" : "password"}
          className="form-control"
          value={dbConfig.password}
          readOnly
        />
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>
      {/* Test connection button */}
      <button
        className="btn btn-outline-primary d-flex align-items-center"
        onClick={testConnection}
        disabled={loading}
      >
        {loading ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Testing...
          </>
        ) : (
          "Test Connection"
        )}
      </button>
    </div>
  );
};

// Export the component as default
export default DatabaseConnection;